<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Steven Sharman holds Honours in Modern History and hails from the Central Coast of New South Wales. A published author of short fiction since 2014, Steven currently lives in Sydney’s Inner West, where he operates an English language coaching business.</p><br/>
<p style="text-indent:0em;">Trained as a historian, Steven writes non-fiction with a focus on Australia’s relations with Asia; his particular expertise relates to the Indonesian annexation of East Timor in 1975.</p><br/>
<p style="text-indent:0em;">Discover samples of Steve Sharman’s short works, including short stories, essays and poems at URL: novelt.info and stevesharm.substack.com</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?32acae97